module.exports = __webpack_public_path__ + "img/error.8a8da68e.png";